// extracted by mini-css-extract-plugin
export default {"disclaimer__icon-container":"style_disclaimer__icon-container__m2agf","disclaimer__text":"style_disclaimer__text__UPuEn"};